import ItodoImage from "../../elements/itodo-img";
import { NavLink } from "react-router-dom";

function TeamPage() {
    return (
        <>
            <div className="section-full p-t110 p-b80 sx-bg-light sx-ourteam-outer ">
                <div className="container">
                    {/* TITLE START */}
                    <div className="section-head center">
                        <div className="sx-head-s-title">Our Team</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title">Infotrace Team Members</h2>
                        </div>
                    </div>
                    {/* TITLE END */}
                    <div className="section-content">
                        <div className="row sx-our-team-section">
                            {/*One block*/}
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="our-team-2">
                                    <div className="profile-image">
                                        <ItodoImage src="images/info-team/AndrewmbuyaCEO.jpg" alt="" />
                                    </div>
                                    <div className="figcaption">
                                        <p>Chief Executive Officer</p>
                                        <h4 className="sx-title"><NavLink to="/about-us">Andrew Mbuya</NavLink></h4>
                                    </div>
                                </div>
                            </div>
                            {/*One two*/}
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="our-team-2">
                                    <div className="profile-image">
                                        <ItodoImage src="images/info-team/christineojuok head of analytics.jpg" alt="" />
                                    </div>
                                    <div className="figcaption">
                                        <p>Head of Data Science and Analytics</p>
                                        <h4 className="sx-title"><NavLink to="/about-us">Christine Ojuok</NavLink></h4>
                                    </div>
                                </div>
                            </div>
                            {/*One three*/}
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="our-team-2">
                                    <div className="profile-image">
                                        <ItodoImage src="images/info-team/Doris lumumba senior data analyst.jpg" alt="" />
                                    </div>
                                    <div className="figcaption">
                                        <p>Senior Data Analyst</p>
                                        <h4 className="sx-title"><NavLink to="/about-us">Dorris Lumumba</NavLink></h4>
                                    </div>
                                </div>
                            </div>
                            {/*One For*/}
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="our-team-2">
                                    <div className="profile-image">
                                        <ItodoImage src="images/info-team/joshuaohato.jpg" alt="" />
                                    </div>
                                    <div className="figcaption">
                                        <p>Data Analyst</p>
                                        <h4 className="sx-title"><NavLink to="/about-us">Joshua Ohato</NavLink></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row sx-our-team-section">
                            {/*One FIve*/}
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="our-team-2">
                                    <div className="profile-image">
                                        <ItodoImage src="images/info-team/shadrackokibo.jpg" alt="" />
                                    </div>
                                    <div className="figcaption">
                                        <p>Data Scientist</p>
                                        <h4 className="sx-title"><NavLink to="/about-us">Shadrack Okibo</NavLink></h4>
                                    </div>
                                </div>
                            </div>
                            {/*One Six*/}
                            <div className="col-lg-3 col-md-6 col-sm-6">
                                <div className="our-team-2">
                                    <div className="profile-image">
                                        <ItodoImage src="images/info-team/hillary.jpg" alt="Hillary Jairus - Lead Data Engineer" />
                                    </div>
                                    <div className="figcaption">
                                        <p>Lead Data Engineer</p>
                                        <h4 className="sx-title"><NavLink to="/about-us">Hillary Jairus</NavLink></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default TeamPage;